import { Building2 } from 'lucide-react';
import { useState, type ReactNode } from 'react';
import { apiUrl } from '../lib/api-client';
import styles from './VentureLogo.module.css';

interface VentureLogoProps {
  readonly venture: { readonly id: string; readonly logoVersion: string | null };
  /** `sm` sits in a menu row or the scope pill; `lg` is the preview on ADMIN-15. */
  readonly size?: 'sm' | 'lg';
}

/**
 * A venture's own logo, or the building icon when it has none (DECISIONS-LOG 2026-10-06).
 * Decorative: the venture's name is always written beside it. A logo that fails to load
 * falls back to the icon rather than showing a broken image.
 */
export function VentureLogo({ venture, size = 'sm' }: VentureLogoProps): ReactNode {
  const [failedVersion, setFailedVersion] = useState<string | null>(null);
  const version = venture.logoVersion;

  if (!version || failedVersion === version) {
    return (
      <span className={`${styles.box} ${styles[size]}`} aria-hidden>
        <Building2 className={styles.icon} />
      </span>
    );
  }
  return (
    <img
      className={`${styles.box} ${styles[size]} ${styles.image}`}
      src={apiUrl(`/organisation/ventures/${venture.id}/logo?v=${version}`)}
      alt=""
      onError={() => setFailedVersion(version)}
    />
  );
}
